// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-navigation-sidebar__places {
  margin-bottom: 8px;
}
.dl-core-navigation-sidebar__header {
  font-size: 15px;
  font-weight: 500;
  height: 56px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}
.dl-core-navigation-sidebar__item {
  display: flex;
  height: 40px;
  padding: 0 16px;
  align-items: center;
  color: var(--g-color-text-complementary);
  -webkit-text-decoration: none;
  text-decoration: none;
  cursor: default;
}
.dl-core-navigation-sidebar__item:hover:not(.dl-core-navigation-sidebar__item_current) {
  cursor: pointer;
  color: var(--g-color-text-primary);
  background: var(--g-color-base-simple-hover);
}
.dl-core-navigation-sidebar__item_current {
  color: var(--g-color-text-primary);
  background: var(--g-color-base-selection);
}
.dl-core-navigation-sidebar__item-icon {
  margin-left: 7px;
  margin-right: 18px;
}
.dl-core-navigation-sidebar__quick-header {
  height: 32px;
  padding: 8px 20px 0;
  line-height: 24px;
  color: var(--g-color-text-hint);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/Sidebar/Sidebar.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AADR;AAII;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,wCAAA;EACA,6BAAA;EAAA,qBAAA;EACA,eAAA;AAFR;AAIQ;EACI,eAAA;EACA,kCAAA;EACA,4CAAA;AAFZ;AAKQ;EACI,kCAAA;EACA,yCAAA;AAHZ;AAOI;EACI,gBAAA;EACA,kBAAA;AALR;AAQI;EACI,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,+BAAA;AANR","sourcesContent":[".dl-core-navigation-sidebar__places {\n  margin-bottom: 8px;\n}\n.dl-core-navigation-sidebar__header {\n  font-size: 15px;\n  font-weight: 500;\n  height: 56px;\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n}\n.dl-core-navigation-sidebar__item {\n  display: flex;\n  height: 40px;\n  padding: 0 16px;\n  align-items: center;\n  color: var(--g-color-text-complementary);\n  text-decoration: none;\n  cursor: default;\n}\n.dl-core-navigation-sidebar__item:hover:not(.dl-core-navigation-sidebar__item_current) {\n  cursor: pointer;\n  color: var(--g-color-text-primary);\n  background: var(--g-color-base-simple-hover);\n}\n.dl-core-navigation-sidebar__item_current {\n  color: var(--g-color-text-primary);\n  background: var(--g-color-base-selection);\n}\n.dl-core-navigation-sidebar__item-icon {\n  margin-left: 7px;\n  margin-right: 18px;\n}\n.dl-core-navigation-sidebar__quick-header {\n  height: 32px;\n  padding: 8px 20px 0;\n  line-height: 24px;\n  color: var(--g-color-text-hint);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
